import SingleChoice from 'modules/core/components/Filter/filters/SingleChoice'
import i18n from 'modules/core/lib/i18n'

import { InsightTableGroupBy } from 'modules/finance/components/FinancialWorkspace/types/table'

import { groups } from '../const'

interface Props {
  group?: InsightTableGroupBy
  onChange: (value?: InsightTableGroupBy) => void
}

export const GroupBySelector = ({ group, onChange }: Props) => {
  return (
    <SingleChoice
      label={i18n.t('finance.financial_workspace.breakdown_table.group_by.title')}
      value={group}
      onValueChange={(value) => onChange(groups().find((option) => option.value === value)?.value)}
      options={groups()}
    />
  )
}
